import {
	getController,
	apiService as Service,
	type HpRequestPostPut,
} from '@/services/service'

const url = 'faqcategories'

export const faqCategoryService = {
	...getController<
		Api.FaqCategory,
		Api.FaqCategoryPostInput,
		Api.FaqCategoryUpdateInput
	>(url),
	ordering: (data?: HpRequestPostPut<Api.FaqCategoryOrderingUpdateInput>) =>
		Service.post({
			url: `${url}/ordering`,
			...data,
			headers: {
				...data?.headers,
				'Content-Type': 'multipart/form-data',
			},
		}),
}
